import { defineComponent as r, createElementBlock as t, openBlock as o, createBlock as s, renderSlot as n, createCommentVNode as a, normalizeClass as l } from "vue";
import i from "../LoadingSkeleton.vue.js";
const d = { class: "section-header-wrapper xl:gap-12" }, u = /* @__PURE__ */ r({
  __name: "SectionHeader",
  props: {
    loading: { type: Boolean },
    tight: { type: Boolean }
  },
  setup(p) {
    return (e, c) => (o(), t("div", d, [
      e.loading ? (o(), s(i, { key: 0 })) : (o(), t("div", {
        key: 1,
        class: l(["section-header", { tight: e.tight }])
      }, [
        n(e.$slots, "default", {}, void 0, !0)
      ], 2)),
      e.$slots.links ? n(e.$slots, "links", { key: 2 }, void 0, !0) : a("", !0)
    ]));
  }
});
export {
  u as default
};
